import { SimpleGrid } from '@mantine/core';
import { PlayClipCard } from '@sportybot-web/features/clips/components/clip-card/play-clip-card/play-clip-card';
import { PLAY_CLIPS_RETURN_FIELDS } from '@sportybot-web/services/sporty-gateway/constants';
import { playClipsQueryOptions } from '@sportybot-web/services/sporty-gateway/queries';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/clips/my-clips')({
  component: RouteComponent,
});

function RouteComponent() {
  const CANNED_QUERY = `PlayId = "e1043493-5763-31ba-bb3f-058e8ad71606" AND IdType = "PLAY" Order By Timestamp DESC ${PLAY_CLIPS_RETURN_FIELDS}`;
  const { data } = useQuery({
    ...playClipsQueryOptions({ limit: 10, page: 0, query: CANNED_QUERY }),
  });

  if (!data) {
    return undefined;
  }

  return (
    <SimpleGrid minColWidth={400} spacing="space100">
      {data.search?.plays?.map((play) =>
        play ? <PlayClipCard key={play.id} play={play} /> : undefined,
      )}
    </SimpleGrid>
  );
}
